import { createContext, useContext } from 'react';

export interface FilteredPlansContextValue {
  count: number;
  setCount: (count: number) => void;
}

export const FilteredPlansContext = createContext<FilteredPlansContextValue | null>(null);

export function useFilteredPlansCount(): number {
  const context = useContext(FilteredPlansContext);
  return context?.count ?? 0;
}

export function useSetFilteredPlansCount(): (count: number) => void {
  const context = useContext(FilteredPlansContext);
  return context?.setCount ?? (() => {});
}
